import type { RootState } from '@/app/store';

// Basic selectors
export const selectMaterialDetailData = (state: RootState) =>
  state.materialDetail.materialDetailData;
export const selectMaterialDetailLoading = (state: RootState) =>
  state.materialDetail.loading;
export const selectMaterialDetailError = (state: RootState) =>
  state.materialDetail.error;
